import { render, staticRenderFns } from "./input7MapReceiver.vue?vue&type=template&id=8a24df1a"
import script from "./input7MapReceiver.vue?vue&type=script&lang=js"
export * from "./input7MapReceiver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports